module.exports = __webpack_public_path__ + "static/media/LoaderDNA.112435a1.gif";